import { Button, Card, Input } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast as toastMessage } from "react-toastify";
import { useAppSelector } from "../../../app/store";
import PayrollDisFileIcon from "../../../assets/icons/PayrollDisFileIcon";
import PayrollImportOutlined from "../../../assets/icons/PayrollImportOutlined";
import SearchIcon from "../../../assets/icons/SearchIcon";
import CustomTable from "../../../components/ui/CustomTable";
import PinVerifyModal from "../../../features/portal/vendorPayment/PinVerifyModal";
import {
  useCheckVendorDisbursementQuery,
  useGetAllVendorQuery,
  useGetVendorAmountQuery,
  useVendorPaymentCheckerMutation,
  useVendorPaymentWithOtpMutation,
} from "../../../features/portal/vendorPayment/vendorPaymentApi";
import useDebounce from "../../../hooks/useDebounce";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import ConfirmModalLayout from "../../../layouts/ConfirmModalLayout";
import SidebarLayout from "../../../layouts/SidebarLayout";
import SuccessfullyModalLayout from "../../../layouts/SuccessfullyModalLayout";
import { formatDate, formatTime } from "../../../lib/time";
import { GetAllVendorDataType } from "../../../types/portal/vendorPayment";
import {
  addCommaInNumber,
  countParPageSerialNumber,
} from "../../../utils/number";
import { capitalize } from "../../../utils/string";
import { addKeyInArray } from "../../../utils/utils";
import PayrollImportModal from "./PayrollImportModal";

enum Status {
  "Success" = "status-success",
  "Failed" = "status-danger",
  "Pending" = "status-warning",
}

enum CurrentStage {
  "maker" = "status-dark",
  "checker" = "status-info",
  "approver" = "status-success",
}

export default function PayrollDisbursement() {
  const { id } = useParams();
  const [selectedData, setSelectedData] = useState<any[]>([]);
  // const [pinNumber, setPinNumber] = useState<string>("");
  const [payrollStatus] = useState("true");
  const { user, role } = useAppSelector((state) => state.auth);
  const [vendorPaymentChecker] = useVendorPaymentCheckerMutation();
  // const [vendorPayment] = useVendorPaymentMutation();
  const { keyword, handleInputChange } = useDebounce();
  const [disabled, setDisabled] = useState(false);

  const { page, limit, handlePagination, handleLimit, resetPagination } =
    useTable();
  // useTable(1, role === "checker" || role === "approver" ? 1000 : 10);
  const { open, handleOpen, handleClose } = useModal<
    undefined,
    "CONFIRM_FOR_APPROVAL"
  >();
  const {
    isLoading: isVendorLoading,
    isError: isVendorDetailsError,
    error: vendorDetailsError,
    data: vendorDetails,
    isFetching,
    refetch,
  } = useGetAllVendorQuery({
    params: {
      disbursementBatchCode: id,
      company_id: user?.data?.company_id,
      permission: user?.data?.permission || "all",
      page,
      limit,
      search: keyword,
    },
  });
  // const {
  //   isLoading: isCompanyDetailsLoading,
  //   isError: isCompanyDetailsError,
  //   error: companyDetailsError,
  //   data: companyDetails,
  // } = useGetSingleCompanyQuery(user?.data?.company_id, {
  //   skip: !user?.data?.company_id,
  // });
  // const {
  //   isLoading: isBalanceCheckLoading,
  //   isError: isBalanceCheckError,
  //   error: balanceCheckError,
  //   data: balanceCheck,
  // } = useBalanceCheckQuery(companyDetails?.data?.wallet_number || "", {
  //   skip: !companyDetails?.data?.wallet_number,
  // });
  const {
    isError: isAmountError,
    error: amountError,
    // isLoading: isAmountLoading,
    data: amountData,
  } = useGetVendorAmountQuery({
    params: {
      disbursementBatchCode: id,
      company_id: user?.data?.company_id,
      current_stage: "approver",
    },
  });
  const {
    isError: isDisbursementError,
    error: disbursementError,
    isLoading: isDisbursementLoading,
    data: disbursementData,
    refetch: refetchDisbursement,
  } = useCheckVendorDisbursementQuery(
    {
      params: {
        disbursement_batch_code: String(id),
      },
    },
    {
      skip: role !== "approver",
    }
  );
  const [
    vendorPaymentWithOtp,
    {
      isError: isVendorPaymentError,
      error: vendorPaymentError,
      isLoading: isVendorPaymentLoading,
      isSuccess: isVendorPaymentSuccess,
      data: vendorPaymentData,
    },
  ] = useVendorPaymentWithOtpMutation();
  useError(isVendorDetailsError, vendorDetailsError, "Get payment data fail");
  useError(isVendorPaymentError, vendorPaymentError, "Vendor payment fail");
  // useError(isCompanyDetailsError, companyDetailsError, "Get company data fail");
  // useError(isBalanceCheckError, balanceCheckError, "Get balance data fail");
  useError(isAmountError, amountError, "Get amount data fail");
  useError(
    isDisbursementError,
    disbursementError,
    "Get disbursement data fail"
  );

  // console.log(amountData?.data?.total_amount);

  const vendorAllData = vendorDetails?.data?.data;

  const totalSelectedAmount = selectedData?.reduce(
    (acc, curr) => acc + curr?.amount || 0,
    0
  );

  const columns: ColumnsType<GetAllVendorDataType["data"]["data"][0]> = [
    {
      title: "#SL",
      dataIndex: "index",
      align: "center",
      width: 50,
      render: (_: any, __: any, index: number) =>
        countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      width: 130,
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Transaction Date",
      dataIndex: "transaction_date",
      width: 180,
      render: (val) => (val ? `${formatDate(val)} ${formatTime(val)}` : "-"),
    },
    {
      title: "Amount (BDT)",
      dataIndex: "amount",
      width: 130,
      render: (val) => (val ? addCommaInNumber(val || 0) : "-"),
    },
    {
      title: "Vendor Id",
      dataIndex: "vendor_id",
      width: 100,
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Vendor Name",
      dataIndex: "vendor_name",
      width: 150,
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Wallet Number",
      dataIndex: "wallet_name",
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Current Stage",
      align: "center",
      dataIndex: "current_stage",
      render: (val: keyof typeof CurrentStage) => {
        // const capitalize = (str: string) =>
        //   str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "-";

        // const displayValue = capitalize(value || "-");

        // const status =
        //   role === "maker" && val === "maker"
        //     ? "Request Pending"
        //     : role === "checker" && val === "checker"
        //     ? "Request for Approval"
        //     : role === "approver" && val === "approver"
        //     ? "Paid"
        //     : "Pending";

        return (
          <span className={`status ${CurrentStage[val]}`}>
            {capitalize(val || "")}
          </span>
        );
      },
    },
    {
      title: "Status",
      align: "center",
      dataIndex: "status",
      render: (value?: string) => {
        const displayValue = capitalize(
          value || "pending"
        ) as keyof typeof Status;

        return (
          <span className={`status ${Status[displayValue]}`}>
            {displayValue}
          </span>
        );
      },
    },
    // {
    //   title: "Action",
    //   align: "center",
    //   dataIndex: "id",
    //   render: (val) => (
    //     <Space size={8}>
    //       <Link
    //         to={`/admin/sheba-pay-wallet/payroll-disbursement-details/${val}`}
    //       >
    //         <Button
    //           type="default"
    //           size="small"
    //           className=" bg-white rounded-md outline outline-1 outline-offset-[-1px] outline-zinc-200 inline-flex justify-center items-center gap-0.5 overflow-hidden"
    //           icon={<OrangeEyeIcon />}
    //         >
    //           <span className="justify-start text-orange-500 text-sm font-medium font-['Inter'] leading-normal">
    //             Open
    //           </span>
    //         </Button>
    //       </Link>
    //     </Space>
    //   ),
    // },
  ];

  const handleSendToApprove = async () => {
    if (!selectedData?.length) return;

    // setIsLoading(true);

    try {
      await Promise.all(
        selectedData
          .filter((el) => el?.id)
          .map((el) => vendorPaymentChecker({ id: el?.id }).unwrap())
      );

      // toast("success", "Payment data sent successfully");

      toastMessage.success("Payment data sent successfully");
      setSelectedData([]);
      handleClose();
    } catch (error: any) {
      // toast(
      //   "error",
      //   error?.data?.data?.message || "Failed to send payment data"
      // );

      toastMessage.error(
        error?.data?.data?.message || "Failed to send payment data"
      );
    } finally {
      // setIsLoading(false);
    }
  };

  // console.log(selectedData);

  // const handleApprover = async () => {
  //   if (!selectedData?.length) return;

  //   if (pinNumber === "") {
  //     toastMessage.error("Please enter the pin number");
  //     return;
  //   }

  //   setIsLoading(true);

  //   try {
  //     await Promise.all(
  //       selectedData
  //         .filter((el) => el?.id)
  //         .map((el) =>
  //           vendorPayment({
  //             id: el?.id,

  //             data: {
  //               // sourceWalletPin: "972382",
  //               // amount: el?.amount,
  //               // sourceWallet: "8801111111122",
  //               // destinationWallet: "8801637740137",
  //               pin: pinNumber,
  //             },
  //           }).unwrap()
  //         )
  //     );

  //     toastMessage.success("Payment approved successfully");
  //     // toast("success", "Payment approved successfully");
  //     setSelectedData([]);
  //     handleClose();
  //   } catch (error: any) {
  //     // toast(
  //     //   "error",
  //     //   error?.data?.data?.message || "Failed to approved payment"
  //     // );

  //     toastMessage.error(
  //       error?.data?.data?.message || "Failed to approved payment"
  //     );
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    if (keyword) {
      resetPagination();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword]);

  useEffect(() => {
    if (disabled) {
      setTimeout(() => {
        setDisabled(false);
        refetchDisbursement();
      }, 10000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  useEffect(() => {
    if (isVendorPaymentSuccess) {
      refetchDisbursement();
      setDisabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVendorPaymentSuccess]);

  return (
    <>
      <SidebarLayout
        title="Vendor Payment"
        backLink="/admin/sheba-pay-wallet/payroll-disbursement"
      >
        {payrollStatus === "false" && (
          <Card style={{ width: "100%" }} className="p-5">
            <div className="flex items-center justify-center">
              <PayrollDisFileIcon />
            </div>

            <div className=" mt-6 text-center justify-center text-slate-600 text-sm font-normal font-['Inter'] leading-normal">
              Drag and drop your Excel file (.xlsx, .xls, .csv) here.
            </div>
            <div className=" mt-4 mb-4 text-center justify-center text-slate-600 text-sm font-normal font-['Inter'] leading-normal">
              Or
            </div>

            <div className="flex justify-center items-center">
              <Button
                onClick={() => handleOpen({ type: "IMPORT" })}
                type="default"
                className="h-9 px-3 py-2 bg-Labels-Primary rounded-md outline outline-1 outline-yellow-500 inline-flex justify-center items-center gap-2 overflow-hidden"
                icon={
                  <div className="w-4 h-4 flex justify-center items-center">
                    <PayrollImportOutlined />
                  </div>
                }
              >
                <span className="text-yellow-500 text-sm font-medium font-['Inter'] leading-normal">
                  Import
                </span>
              </Button>
            </div>
          </Card>
        )}

        {/* {isCompanyDetailsLoading ? (
          <Loader />
        ) : role === "all" && companyDetails?.data ? (
          <Card style={{ width: "100%", marginBottom: "25px" }}>
            <div className="flex justify-between items-center">
              <div className="flex justify-start items-center gap-2">
                <img
                  src={companyDetails?.data?.logo || AvatarImage}
                  alt=""
                  className="w-14 h-14 rounded-full"
                />
                <div className="ml-2">
                  <div className="text-blue-500 text-lg font-semibold font-['Inter'] leading-normal">
                    {companyDetails?.data?.company_name}
                  </div>
                  <p className="text-blue-500 text-sm font-medium font-['Inter'] leading-tight">
                    Wallet No: {companyDetails?.data?.wallet_number || "N/A"}
                  </p>
                </div>
              </div>

              {!isBalanceCheckLoading && (
                <BalanceSlide>
                  {addCommaInNumber(
                    Math.round(balanceCheck?.data?.data?.Amount || 0)
                  )}
                  BDT
                </BalanceSlide>
              )}
            </div>
          </Card>
        ) : null} */}

        <CustomTable
          loading={isVendorLoading || isFetching}
          limit={limit}
          page={page}
          columns={columns}
          total={vendorDetails?.data?.count}
          dataSource={addKeyInArray(vendorAllData)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          // hideRowSelect
          rowSelection={
            // || role === "approver"
            role === "checker"
              ? {
                  type: "checkbox",
                  selectedRowKeys: selectedData?.map((el) => el?.key),
                  onChange: (_, record) => {
                    setSelectedData(record as any[]);
                  },
                  getCheckboxProps: (record) => {
                    return role === "checker"
                      ? {
                          disabled: record?.current_stage !== "checker",
                        }
                      : role === "approver"
                      ? {
                          disabled:
                            record?.status === "pending" || !record?.status
                              ? false
                              : true,
                        }
                      : {};
                  },
                  columnWidth: 40,
                }
              : undefined
          }
          filterSection={
            <>
              {/*  || role === "approver" */}
              {role === "checker" ? (
                <div className="px-3 py-1 bg-[#F2F5FF] rounded-[100px] inline-flex justify-center items-center gap-2.5">
                  <div className="justify-start text-[#1B4DFF] text-base font-medium font-['Inter'] leading-7">
                    Total Amount: {addCommaInNumber(totalSelectedAmount || 0)}{" "}
                    BDT
                  </div>
                </div>
              ) : role === "approver" ? (
                <div className="px-3 py-1 bg-[#F2F5FF] rounded-[100px] inline-flex justify-center items-center gap-2.5">
                  <div className="justify-start text-[#1B4DFF] text-base font-medium font-['Inter'] leading-7">
                    Total Amount:{" "}
                    {addCommaInNumber(amountData?.data?.total_amount || 0)} BDT
                  </div>
                </div>
              ) : null}

              <Input
                suffix={<SearchIcon />}
                placeholder="Search by Vendor Id"
                onChange={(e) => handleInputChange(e)}
              />
              {/* 
              {role === "maker" ? (
                <Button
                  onClick={() => handleOpen({ type: "IMPORT" })}
                  type="default"
                  className="h-9 px-3 py-2 bg-Labels-Primary rounded-md outline outline-1 outline-yellow-500 inline-flex justify-center items-center gap-2 overflow-hidden"
                  icon={
                    <div className="w-4 h-4 flex justify-center items-center">
                      <PayrollImportOutlined />
                    </div>
                  }
                >
                  <span className="text-yellow-500 text-sm font-medium font-['Inter'] leading-normal">
                    Import
                  </span>
                </Button>
              ) : null} */}

              {role === "checker" ? (
                <Button
                  className="middle-button min-w-[150px]"
                  type="primary"
                  disabled={!selectedData?.length}
                  onClick={() => handleOpen({ type: "CONFIRM" })}
                  // loading={isLoading}
                >
                  Send to Approver
                </Button>
              ) : null}

              {role === "approver" ? (
                <Button
                  className="middle-button min-w-[150px]"
                  type="primary"
                  disabled={
                    isDisbursementLoading ||
                    disbursementData?.data?.result !== false ||
                    isVendorLoading ||
                    disabled
                  }
                  onClick={() => handleOpen({ type: "CONFIRM_FOR_APPROVAL" })}
                >
                  Approve
                </Button>
              ) : null}
            </>
          }
        />

        {open?.type === "IMPORT" && (
          <PayrollImportModal
            open={open.open}
            isBatchName={true}
            data={vendorDetails?.data?.count! + 1}
            handleClose={handleClose}

            // reRender={reRender}
            // uploadedCount={}
          />
        )}

        {open?.type === "SUCCESS" && (
          <SuccessfullyModalLayout
            title={<span>Successfully Uploaded!</span>}
            buttonName="View"
            buttonBgDeep={false}
            handleButton={handleClose}
            open={open?.open}
            handleClose={handleClose}
          />
        )}

        {open?.type === "CONFIRM" && (
          <ConfirmModalLayout
            title="Send to Approver"
            subTitle="Are you sure you want to send payment data to approver"
            buttonName="Send"
            handleButton={handleSendToApprove}
            open={open?.open}
            handleClose={handleClose}
            action
            buttonBgDeep
            // loading={isLoading}
          />
        )}

        {open?.type === "CONFIRM_FOR_APPROVAL" && (
          <PinVerifyModal
            open={open?.open}
            handleClose={handleClose}
            refetch={refetch}
            isPaymentLoading={isVendorPaymentLoading}
            isPaymentSuccess={isVendorPaymentSuccess}
            paymentApi={vendorPaymentWithOtp}
            paymentMessage={
              vendorPaymentData?.message || "Payment approved successfully"
            }
          />
          // <ApprovedModal
          //   open={open?.open}
          //   handleClose={handleClose}
          //   refetch={refetch}
          // />
          // <ConfirmModalLayout
          //   title="Approve"
          //   subTitle="Are you sure you want to approve payment"
          //   buttonName="Approved"
          //   handleButton={handleApprover}
          //   open={open?.open}
          //   handleClose={() => {
          //     handleClose();
          //     refetch();
          //     setSelectedData([]);
          //   }}
          //   action
          //   buttonBgDeep
          //   loading={isLoading}
          // >
          //   <Form.Item
          //     // label="Pin Number"
          //     name="pn"
          //     rules={[
          //       {
          //         required: true,
          //         message: "Please enter pin number",
          //       },
          //       {
          //         pattern: /^\d{6,}$/,
          //         message: "Pin number must be at least 6 digits",
          //       },
          //     ]}
          //   >
          //     <Input
          //       placeholder="Enter pin number"
          //       onChange={(e) => setPinNumber(e.target.value)}
          //     />
          //   </Form.Item>
          // </ConfirmModalLayout>
        )}
      </SidebarLayout>
    </>
  );
}
